export const maxHours = 99;
export const maxMinutes = 59;
export const maxSeconds = 59;

export const placeholderChar = '-';
export const format = 'HH:MM:SS';
export const placeholder = 'hh:mm:ss.ss';
export const mask = [/\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/, '.', /\d/, /\d/];
